<template>
    <b-form-group :label="label" :label-for="uuid">
        <b-input-group :size="size">
            <b-input-group-prepend v-if="showButtons">
                <b-btn variant="outline-info" @click="value--">-</b-btn>
            </b-input-group-prepend>

            <b-form-input v-model="value"
                          :state="state"
                          :id="uuid"
                          :disabled="disabled"
                          :debounce="debounce"
                          :placeholder="placeholder"
                          type="number"/>
            <b-form-invalid-feedback>{{feedback}}</b-form-invalid-feedback>

            <b-input-group-append v-if="showButtons">
                <b-btn variant="outline-secondary" @click="value++">+</b-btn>
            </b-input-group-append>
        </b-input-group>
    </b-form-group>
</template>

<script>
export default {
    name: 'NumberInput',
    props: {
        label: { type: String, default: null, },
        state: { type: Boolean, default: null, },
        feedback: { type: String, default: null, },
        initialValue: { default: null, },
        disabled: { type: Boolean,default: false, },
        size: { type: String, default: 'md', },
        debounce: { type: Number, default: 0, },
        placeholder: { type: String, default: null, },
        showButtons: { type: Boolean, default: false, },
    },
    data() {
        return {
            uuid: this.$uuid.v1(),
        };
    },
    computed: {
        value: {
            get: function() {
                return this.initialValue;
            },
            set: function(newValue) {
                this.$emit('value-change', newValue);
            },
        },
    },
}
</script>
